import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NoteToCandidateAndRefereeComponent } from './note-to-candidate-and-referee.component';
import { BannerModule, TooltipModule as xrefTooltipModule } from '@xref/xref-lib';
import { AlertModule } from 'ngx-bootstrap/alert';
import {TooltipModule} from "ngx-bootstrap/tooltip";
import { OptInQuestionModule } from '../opt-in-question/opt-in-question.module';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { CharacterLimitModule } from '../character-limit/character-limit.module';

@NgModule({
  declarations: [NoteToCandidateAndRefereeComponent],
  imports: [CommonModule,
      FormsModule,
      BannerModule,
      AlertModule.forRoot(),
      OptInQuestionModule,
      TooltipModule.forRoot(),
      CharacterLimitModule,
      TooltipEllipsifyModule,
      xrefTooltipModule,],
  exports: [NoteToCandidateAndRefereeComponent]
})
export class NoteToCandidateAndRefereeModule {}
